import { registerComponent } from '@gig/magic-common';
import BadgeComponent from './badge.vue.js';

var Badge = registerComponent(BadgeComponent);

export { Badge };
